import apiClient from "./apiClient";

export const fetchCouponUsers = async (params = {}) => {
  try {
    const { search = "", page = 1, limit = 10, almataId, oemId } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(almataId && { almataId }),
      ...(oemId && { oemId })
    });
    const response = await apiClient.get(`/partners/almata-partners/oem-partners/coupon-usage?${queryParams}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};